import React from 'react';
export var IconPaymentAmex = function IconPaymentAmex(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? '32' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '50' : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    "data-testid": "icon-payment-amex",
    height: height,
    width: width,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    height: "32",
    rx: "6",
    transform: "translate(.82)",
    width: "50"
  }), /*#__PURE__*/React.createElement("rect", {
    height: "31",
    rx: "6",
    stroke: "#BBBBBE",
    transform: "translate(.82)",
    width: "48",
    x: ".5",
    y: ".5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.82 5v22h22v-3.476h-3.036l-1.122-1.313-1.166 1.313h-8.624v-6.989h-2.846l3.557-8.052h3.462l.836 1.826V8.483h4.297l.72 1.914.702-1.914h3.22V5h-22Zm19.514 4.62-1.13 2.977-.3.806-.308-.806L31.46 9.62h-2.486v5.866h1.496v-3.821l-.007-.769.293.769 1.43 3.821h1.423l1.438-3.821.278-.762v4.583h1.496V9.62h-2.486Zm-9.944 0-2.596 5.866h1.701l.455-1.129h2.845l.455 1.129h1.723l-2.58-5.866H24.39Zm.69 1.987.293-.734.293.734.608 1.481h-1.803l.608-1.481Zm9.372 4.935-1.768 1.899-1.76-1.899h-6.849v5.845h4.898v-1.269h-3.402v-1.019h3.337v-1.261h-3.337v-1.027h3.402v-1.269l2.736 2.934-2.736 2.911h1.892l1.782-1.907 1.775 1.907h1.943l-2.742-2.933 2.742-2.912h-1.913Zm.711 2.904 1.657 1.687v-3.351l-1.657 1.664Z",
    fill: "#006FCF"
  })));
};